import React, {createRef, PureComponent} from 'react';
import { Typo3Files } from '../provider/Typo3Provider/types';
import AspectRatio from './layout/AspectRatio';
import { Video } from './Video';

interface TypoVideoProps {
  file?: Typo3Files;
  aspectRatioWidth?: number;
  aspectRatioHeight?: number;
  play?: boolean;
  muted?: boolean;
}

class TypoVideo extends PureComponent<TypoVideoProps> {
    private videoRef = createRef<HTMLVideoElement>();

    public componentDidMount() {
        if (this.videoRef.current) {
            if(this.props.play) {
                this.videoRef.current.play();
            } else {
                this.videoRef.current.pause();
            }
        }
    }

    public componentDidUpdate(prevProps: TypoVideoProps) {
        if (prevProps.play !== this.props.play) {
            if (this.videoRef.current) {
                if(this.props.play) {
                    this.videoRef.current.play();
                } else {
                    this.videoRef.current.pause();
                }
            }
        }
    }

    public render() {
        const { file, aspectRatioWidth = 16, aspectRatioHeight = 9, muted = false} = this.props;
        const { image, assets } = file || { image: [], assets: [] };
        const [videoFile = null] = assets || [];
        const [posterFile = null] = image || [];
        return videoFile ? (
            <AspectRatio width={aspectRatioWidth} height={aspectRatioHeight}>
                <Video
                    innerRef={this.videoRef}
                    src={videoFile.imageUri}
                    poster={posterFile ? posterFile.imageUri : undefined}
                    controls
                    autoPlay
                    muted={muted}
                    onCanPlay={() => window.Matomo?.MediaAnalytics.scanForMedia() }
                />
            </AspectRatio>
        ) : null;
    }
}

export default TypoVideo;
